import { useToast } from '@/hooks/use-toast';

export type EmailTemplate = 
  | 'welcome'
  | 'subscription_updated'
  | 'subscription_cancelled'
  | 'role_updated'
  | 'family_invitation';

interface EmailOptions {
  to: string;
  template: EmailTemplate;
  data?: Record<string, any>;
}

const TEMPLATES: Record<EmailTemplate, { subject: string; body: string }> = {
  welcome: {
    subject: 'Welcome to Scienza Health',
    body: 'Welcome aboard! We\'re excited to have you join us.',
  },
  subscription_updated: {
    subject: 'Subscription Update',
    body: 'Your subscription has been updated to {{tier}}.',
  },
  subscription_cancelled: {
    subject: 'Subscription Cancelled',
    body: 'We\'re sorry to see you go. Your subscription has been cancelled.',
  },
  role_updated: {
    subject: 'Role Update',
    body: 'Your role has been updated to {{role}}.',
  },
  family_invitation: {
    subject: 'Family Invitation',
    body: '{{inviter}} has invited you to join their family group.',
  },
};

export const useEmailService = () => {
  const { toast } = useToast();

  const sendEmail = async ({ to, template, data = {} }: EmailOptions) => {
    try {
      // Mock email sending - replace with actual email service
      const templateContent = TEMPLATES[template];
      let body = templateContent.body;
      
      // Replace template variables
      Object.entries(data).forEach(([key, value]) => {
        body = body.replace(`{{${key}}}`, value);
      });

      console.log('Sending email:', {
        to,
        subject: templateContent.subject,
        body,
      });

      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));

      toast({
        title: "Email Sent",
        description: `Email has been sent to ${to}`,
      });

      return true;
    } catch (error) {
      console.error('Failed to send email:', error);
      toast({
        title: "Email Failed",
        description: "Failed to send email. Please try again.",
        variant: "destructive",
      });
      return false;
    }
  };

  const sendWelcomeEmail = async (email: string, name: string) => {
    return sendEmail({
      to: email,
      template: 'welcome',
      data: { name }
    });
  };

  return { sendEmail, sendWelcomeEmail };
};